module.exports = __webpack_public_path__ + "static/img/choosebg.f955963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/choosebg.png
// module id = fOWu
// module chunks = 1